/* eslint-disable import/no-unused-modules */
/*
  Route path and their types declarations

  Warning:
    Here we can't inherit one path by another, coz for unknown reasons typescript doesn't understand resulted const
    in the generatePath function after importing that one and strong types doesn't work at all.
    But if we typing something like `${basePath}/:param` directly in the generatePath, that works.
    Some research needed.
*/

export const ADVERSE_MEDIA_PATH = '/adverse-media'
export const CLIENT_USERS_PATH = '/app-settings/users'
export const BANK_USERS_PATH = '/users'
export const BANK_INVOICES_PATH = '/invoices'
export const BANK_CLIENT_USERS_PATH = '/client-users'
export const CLIENT_USER_PROFILE_PATH = '/app-settings/user-profile'
export const INTERNAL_TRANSFERS_PATH = '/internal-transfers'
export const COMPANIES_PATH = '/relationships'
export const LICENSES_PATH = '/licenses'
export const LICENSES_PATH_DETAILS = `/licenses/$licensesId`
export const DOCUMENTS_PATH = '/documents'
export const NEXT_CLOUD_LOGIN = '/nextcloud'

export const BANK_ANNUAL_REVIEW = '/annual-review'
export const BANK_ANNUAL_REVIEW_DETAIL = '/annual-review/detail'
export const CONTACTS_PATH = '/contacts'
export const BANK_ACCOUNTS = '/bank-accounts'
export const REPORTS_PATH = '/reports'
export const HISTORY_PATH = '/history'
export const BSA_MODULE_PATH = '/bsa'
export const KEY_CONNECTIONS_PATH = '/key-connections'

export const BSA_CTR_PATH = '/bsa/ctrs'

export const BSA_CTR_BATCH_PATH = '/bsa/ctr-batch-list'
export const AUTH_PATH = '/auth'
export const MR_PATH = '/mr'
export const QR_PATH = '/qr'
export const SALESDATA_PATH = '/salesdata'

// Licenses

export enum LicensesPath {
  DETAILS = '/licenses/$licenseId',
  CREATE = '/licenses/add',
  EDIT = '/licenses/$licenseId/edit'
}

// Contacts

export enum ContactsPath {
  DETAILS = '/contacts/$contactId'
}

// Bank Accounts
export enum BankAccountsPath {
  DETAILS = '/bank-accounts/$bankAccountId',
  EDIT = '/bank-accounts/$bankAccountId/edit'
}

/* BP Applications + Onboarding */
export enum BankApplicationPaths {
  LIST = '/onboarding/applications',
  DETAILS = '/onboarding/applications/$applicationId',
  EDIT = `/onboarding/applications/edit/$applicationId`
}

// using in router
export enum BankApplicationsRouterPaths {
  INDEX = `/onboarding/applications`,
  LIST = `/`,
  DETAILS = `$applicationId`,
  EDIT = `edit/$applicationId`
}

export enum ClientOnboardingPath {
  EDIT = `/onboarding/$applicationId`
}

export const routes = {
  bank: {
    relationships: {
      index: '/relationships',
      details: '/relationships/$id',
      edit: '/relationships/edit/$id',
      contact: {
        edit: '/relationships/$id/contact/edit/$contactId',
        add: '/relationships/$id/contact/add/$contactId'
      }
    },
    contacts: {
      index: '/contacts',
      details: '/contacts/$contactId'
    },
    bankAccounts: {
      details: '/bank-accounts/$id',
      edit: '/bank-accounts/$id/edit',
      create: '/bank-accounts/new'
    },
    licenses: {
      details: '/licenses/$licenseId',
      create: '/licenses/add',
      edit: '/licenses/$licenseId/edit'
    },
    application: {
      list: '/onboarding/applications',
      details: '/onboarding/applications/$applicationId',
      edit: '/onboarding/applications/edit/$applicationId',
      warningsDetails: '/onboarding/applications/$applicationId/warnings-details'
    },
    documentTemplates: {
      index: '/document-templates',
      details: '/document-templates/$id',
      manage: '/document-templates/$id/edit'
    },
    documents: {
      index: '/documents',
      details: '/documents/$documentId',
      new: '/documents/new'
    },
    reports: {
      index: '/reports',
      documentTemplates: {
        index: '/reports/documents'
      },
      siteAuditDocuments: {
        index: '/reports/compliance-review'
      },
      emailHistoryReport: {
        index: '/reports/email-history'
      },
      user: {
        index: '/reports/user'
      },
      client: {
        index: '/reports/client'
      },
      relationships: {
        index: '/reports/relationships'
      },
      applicationPipeline: {
        index: '/reports/application-pipeline'
      },
      alerts: {
        index: '/reports/alerts'
      },
      documentStatus: {
        index: '/reports/document-status'
      }
    },
    hrr: {
      index: '/hrr',
      details: '/hrr/$id',
      create: '/hrr/$id/edit'
    },
    bsa: {
      index: '/bsa',
      sar: {
        index: '/bsa/sars',
        details: '/bsa/sars/$id',
        edit: '/bsa/sars/$id/edit',
        changes: '/bsa/sars/$id/warnings-details'
      }
    },
    clientUsers: {
      index: '/client-users',
      list: '/client-users/'
    },
    adverseMedia: {
      index: '/adverse-media'
    },
    onboardingDocuments: {
      index: '/application/$applicationId/onboarding-documents',
      details: '/application/$applicationId/onboarding-documents/$id/details'
    },
    annualReview: {
      details: '/annual-review/detail/$companyId/$id',
      salesDepositsOnRoute: '/$annualReviewId/edit-sales-and-deposit/$id',
      salesDeposits: '/annual-review/$annualReviewId/edit-sales-and-deposit/$id',
      salesDepositsOldRoute: '/edit-sales-and-deposit/$companyId/$annualReviewId/$salesAndDepositId'
    },
    customerVendors: {
      index: '/customer-vendors',
      details: '/customer-vendors/$id'
    },
    settings: '/account-settings',
    alerts: '/alerts'
  },
  client: {
    settings: {
      connections: {
        index: '/app-settings/connections',
        biotrack: '/app-settings/connections/biotrack',
        metrc: '/app-settings/connections/metrc'
      }
    }
  }
} as const

type RoutePaths<T> = T extends string
  ? T
  : T extends object
    ? {
        [K in keyof T]: RoutePaths<T[K]>
      }[keyof T]
    : never

export type AllRoutePaths = RoutePaths<typeof routes>
